import { render, staticRenderFns } from "./publicCalendar.vue?vue&type=template&id=6a4f4b6a&scoped=true"
import script from "./publicCalendar.vue?vue&type=script&lang=js"
export * from "./publicCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4f4b6a",
  null
  
)

export default component.exports